import React, { useState, useEffect } from 'react';
import { useLanguage } from '../../../context/LanguageContext';
import { useNavigate, useParams } from 'react-router-dom';
import { fetchPlantsByName } from '../../../api/api_plants';
import loadDynamicImage from '../../Entities/ImageLoader'; 
import loadingGif from '../../assets/loading.gif';

const PlantDetails = () => {
    const { translations } = useLanguage();
    const { plantName } = useParams();
    const [plant, setPlant] = useState(null);
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const sunlightLevelMapping = {
        0: translations.no_light,
        1: translations.low_ambient_light,
        2: translations.ambient_light,
        3: translations.indirect_solar_light,
        4: translations.direct_solar_light,
      };

    const getSunlightLevelText = (sunlight_level) => {
        return sunlightLevelMapping[sunlight_level] || translations.unknown_sunlight_level;
    };
    

    useEffect(() => {
        const fetchPlantDetails = async () => {
            try {
                const response = await fetchPlantsByName(plantName);
                if (response && response.data) {
                    setPlant(response.data[0]);
                } else {
                    throw new Error('Plant not found');
                }
            } catch (error) {
                console.error(translations.error_fetching_plant_details + ':', error);
                setPlant(null);
                if (error.response && error.response.status === 404) {
                    setError(translations.plant_not_found);
                } else {
                    setError(translations.error_fetching_plant_details);
                }
            }
        };

        fetchPlantDetails();
    }, [plantName, translations]);

    const handleBack = () => navigate(-1);

    return (
        <div className="plant-page">
            <div className="sm-container">
                <div className="header">
                    <button onClick={handleBack} className="back-button">&#8592;</button>
                    <h1>{translations.plant_details}</h1>
                </div>
                {error && <p className="error-message">{error}</p>}
                {plant ? (
                    <div className="space-info">
                        <h2>{plant.name}</h2>
                        <p className="custom-paragraph"><strong>{translations.ideal_temperature}:</strong> {plant.max_temperature} -- {plant.min_temperature}</p>
                        <p className="custom-paragraph"><strong>{translations.ideal_minerals}:</strong> {plant.max_minerals} -- {plant.min_minerals}</p>
                        <p className="custom-paragraph"><strong>{translations.ideal_ground_humidity}:</strong> {plant.max_ground_humidity} -- {plant.min_ground_humidity}</p>
                        <p className="custom-paragraph"><strong>{translations.ideal_air_humidity}:</strong> {plant.max_air_humidity} -- {plant.min_air_humidity}</p>
                        <p className="custom-paragraph"><strong>{translations.sunlight_level}:</strong> {getSunlightLevelText(plant.sunlight_level)}</p>
                        <img
                        className='plant-image'
                        src={loadDynamicImage(plantName) || loadingGif}
                        alt={plant?.name || translations.loading}
                        />
                    </div>
                ) : (
                    <div className='pot-loading'> <img src={loadingGif} alt={translations.loading} /> </div>
                )}
            </div>
        </div>
    );
}

export default PlantDetails;
